import { Button, styled } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { pages } from "../pages/pages";

const NotFound: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Container>
            <div>{t("not_found")}</div>
            <div style={{ marginTop: 20 }}>
                <Button onClick={() => navigate(pages.home)} variant="contained">
                    {t("back_to_home")}
                </Button>
            </div>
        </Container>
    );
};

export default NotFound;

const Container = styled("div")`
    width: 100%;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;
